import theme from "../../../theme";

/**
 * Styles for the main container of the FilteringPaginationSx components.
 * @type {object}
 */
export const container = {
  display: "flex",
  width: "100%",
  borderRadius: 6,
};

/**
 * Styles for the filter and list section.
 * @type {object}
 */
export const contentBox = {
  flex: "1",
  display: "flex",
  flexDirection: "column",
  background: theme.palette.background.paper,
  borderRadius: 6,
  margin: "1rem",
  padding: "1.5rem"
};

/**
 * Styles for the padding around the filter elements.
 * @type {object}
 */
export const filterPadding = {
  padding: "1.5rem",
};

/**
 * Styles for the padding around the filter elements.
 * @type {object}
 */
export const headingContainer = {
  // padding: "1.5rem",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center"
};

/**
 * Styles for the title of the upcoming cars section.
 * @type {object}
 */
export const title = {
  fontWeight: "600",
  color: theme.palette.primary.main,
  marginBottom: "1rem",
  fontSize: `${32 / 16}rem`,
};

/**
 * Styles for the container of the filter inputs.
 * @type {object}
 */
export const filterInputsContainer = {
  display: "flex",
  gap: "1rem",
  flexWrap: "wrap",
};

/**
 * Styles for individual filter input boxes.
 * @type {object}
 */
export const filterInputBox = {
  width: "23%",
};

/**
 * Styles for the year selection container.
 * @type {object}
 */
export const yearSelectContainer = {
  display: "flex",
  gap: "0.5rem",
};

/**
 * Styles for the odometer input container.
 * @type {object}
 */
export const odometerInputContainer = {
  display: "flex",
  gap: "0.5rem",
};

/**
 * Styles for the container of selected brand chips.
 * @type {object}
 */
export const selectedBrandsContainer = {
  marginTop: "1rem",
  display: "flex",
  gap: "0.5rem",
};

/**
 * Styles for individual selected brand chips.
 * @param {object} theme - The Material-UI theme object.
 * @returns {object} - Styles for the chip.
 */
export const selectedBrandChip = {
  borderColor: theme.palette.primary.main,
  color: theme.palette.primary.main,
  "& .MuiChip-deleteIcon": {
    color: theme.palette.primary.main,
    "&:hover": { color: theme.palette.primary.main },
  },
};
